module.exports = __webpack_public_path__ + "static/zentralasien-b639158e5d4ba8255f9efe7114eb04fb.svg";